module.exports = __webpack_public_path__ + "arrow.svg?6f3a534027e0de054c52d902ef9c86b9";